/**
 *
 * @param {*} facturaServicioQuery
 * @returns
 */
export function fnPeriodosRentaQuery(facturaServicioQuery) {
  return {
    model: 'MaqBitacoraPeriodoPago',
    required: false,

    attributes: [
      'iId',
      ['sPeriodo', 'periodo'],
      ['dInicio', 'inicio'],
      ['dFin', 'fin'],
      ['iAdicional', 'adicional'],
      ['sStatusAdicional', 'status_ad'],
    ],

    include: [facturaServicioQuery()],

    where: {
      iActivo: true,
    }
  }
}
